import axios from "axios";

export const biApi = axios.create({
  baseURL: `${window.__PATH__?.appUrls?.businessIntelligence}api/`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

/* --------------------------------------------------------------------------------------------- */
/* --------------------------------------------------------------------------------------------- */
/* --------------------------------------------------------------------------------------------- */
